import type { FunctionComponent } from 'react'
import React from 'react'
import { Grid, GridItem } from '@which/seatbelt'

import classnames from 'classnames'

import type { PolicyAndInsightLandingContentItem } from '../../../../../generated/frontend'
import { BasicHeader } from '../../../../../shared/components/BasicHeader'
import { ComponentWrapper } from '../../../../../shared/components/ComponentWrapper'
import { SectionJumpLinks } from '../../../../../shared/components/SectionJumpLinks'
import styles from './PILandingPageSections.module.scss'

export const PILandingPageSections: FunctionComponent<Props> = ({ contentItems }) => {
  if (!contentItems.length) {
    return null
  }

  return (
    <GridItem
      span={{ medium: 12, large: 12 }}
      columnStart={{ medium: 1, large: 1 }}
      className={styles.PILandingPageSectionContainer}
    >
      {contentItems.map(({ type, data }, index) => {
        const Component = componentMapper[type]
        if (Component) {
          const fullWidthBackgroundColour = data?.customData?.data
            ? data?.customData?.data.fullWidthBackgroundColour
            : ''
          const backgroundColour = data?.customData?.data
            ? data?.customData?.data.backgroundColour
            : ''
          const bgColor = backgroundColour || ''

          const jumpLinksExist = type === 'jumpLinks' ? true : false

          return (
            <Grid
              key={`grid-section-${index}`}
              includeGutters={false}
              className={classnames(styles.PILandingPageSection, {
                [styles.PILandingPageSectionBorder]: jumpLinksExist,
              })}
              style={!fullWidthBackgroundColour ? { backgroundColor: bgColor } : {}}
            >
              <Component {...data} key={`${type}-${index}`} largerMargin />

              {fullWidthBackgroundColour && (
                <div
                  className={styles.petitionSectionBackground}
                  style={{ backgroundColor: bgColor }}
                ></div>
              )}
            </Grid>
          )
        }
        // return null once petition page is complete
        return (
          <div key={`notype-${index}`}>
            Data not mapped for component {type} ~ CampaignPetitionSections
          </div>
        )
      })}
    </GridItem>
  )
}

///////// IMPLEMENTATION /////////

type Props = {
  contentItems: PolicyAndInsightLandingContentItem[]
}

const componentMapper: Record<string, FunctionComponent<any>> = {
  ['component-wrapper']: ComponentWrapper,
  ['jumpLinks']: SectionJumpLinks,
  ['header']: BasicHeader,
}
